import styled from '@emotion/styled';

export const Box = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  overflow: hidden;
`;

export const ErrorText = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.red[200]};
  white-space: pre-line;
  word-break: break-all;
`;

export const GuideText = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral[500]};
  white-space: pre-line;
  word-break: break-all;
`;
